import { render, staticRenderFns } from "./businessClass.vue?vue&type=template&id=5ed6fd22&scoped=true"
import script from "./businessClass.vue?vue&type=script&lang=js"
export * from "./businessClass.vue?vue&type=script&lang=js"
import style0 from "./businessClass.vue?vue&type=style&index=0&id=5ed6fd22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed6fd22",
  null
  
)

export default component.exports